export default __webpack_public_path__ + "static/media/(1)-Dulce-de-leche.73e730ee.jpg";